<template lang="html">
  <booking-events
    v-bind="$attrs"
    :headers="headers"
    :createNewItem="createNewItem"
  >
    <template v-slot:itemForm="slotProps">
      <booking-event-form v-bind="slotProps"></booking-event-form>
    </template>

    <template v-slot:item.guests="{item}">
      <span>{{`${item.guests} (${item.guests_children})`}}</span>
    </template>

  </booking-events>
</template>

<script>
import {BookingEvents} from 'dync-booking'
import BookingEventForm from './BookingEventForm.vue';

export default {
  inheritAttrs: false,
  data() {
    return {
      headers: [
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: 'Contact',
          value: '_contactName'
        },
        {
          text: 'Guests',
          value: 'guests'
        },
        {
          text: 'Date',
          value: 'date',
          sortable: false
        },
        {
          text: 'Start',
          value: 'from'
        },
        {
          text: 'End',
          value: 'to'
        },
        {
          text: 'Tables',
          value: '_resourceNames'
        },
        {
          text: 'Booking number',
          value: 'booking_number'
        },
        {
          text: 'Comment',
          value: 'comment'
        },
        {
          text: 'Created At',
          value: 'created_at'
        }
      ]
    }
  },
  methods: {
    createNewItem() {
      return {
        guests_children: 0,
        status: 'confirmed'
      };
    }
  },
  components: {
    BookingEvents,
    BookingEventForm
  }
}
</script>

<style lang="css" scoped>
</style>
